// chargeModel.js — 1:1급여 정산 탭의 직원 상태 분류·정렬 (2026-10-06 UX)
//   확인 필요 = 넣을지 뺄지 정하지 않은 계약·취소가 있음(확정을 막음, 주황)
//   점검     = 금액이 이상할 수 있는 경고(월급 미입력·계산 제외·이번 달 재직 없음, 빨강) — 확정은 막지 않음
//   참고     = 알고만 있으면 되는 것(입사·퇴사로 기간이 잘림·재계약 제외·뺀 계약, 회색)
//   서버가 주는 warnings 글자를 그대로 나눠 쓴다(계산은 서버, 화면은 분류만).

export function rowPendingCount(row) {
  return (row?.events || []).filter((event) => event.chargeDecisionStatus === 'pending').length;
}

const CHECK_PATTERNS = [/월급 미입력/, /계산 제외/, /이번 달 재직 없음/];
// 확인필요·제외 건수는 따로(목록·상세의 '확인 필요'·'뺀 계약') 보여 주므로 경고 묶음에서는 뺀다
const SKIP_PATTERNS = [/1:1 청구 확인필요/];

export function classifyWarnings(row) {
  const checks = [];
  const notes = [];
  for (const raw of row?.warnings || []) {
    const text = String(raw || '').trim();
    if (!text || SKIP_PATTERNS.some((re) => re.test(text))) continue;
    if (CHECK_PATTERNS.some((re) => re.test(text))) checks.push(text);
    else notes.push(text.replace('1:1 청구 제외', '뺀 계약').replace('재계약 제외 있음', '재계약 제외'));
  }
  return { checks, notes };
}

/** 'pending' | 'check' | 'ok' */
export function rowState(row) {
  if (rowPendingCount(row) > 0) return 'pending';
  if (classifyWarnings(row).checks.length > 0) return 'check';
  return 'ok';
}

const STATE_ORDER = { pending: 0, check: 1, ok: 2 };

export function sortRows(rows = []) {
  return [...rows].sort((a, b) => (
    STATE_ORDER[rowState(a)] - STATE_ORDER[rowState(b)]
    || String(a.consultantName || '').localeCompare(String(b.consultantName || ''), 'ko')
  ));
}

export function stateCounts(rows = []) {
  return rows.reduce((acc, row) => {
    acc[rowState(row)] += 1;
    return acc;
  }, { pending: 0, check: 0, ok: 0 });
}

export function noteCount(rows = []) {
  return rows.reduce((sum, row) => sum + classifyWarnings(row).notes.length, 0);
}

/** 지금 직원 다음의 확인 필요 직원(정렬 순서 기준, 없으면 처음부터) */
export function nextPendingId(rows = [], currentId = null) {
  const sorted = sortRows(rows).filter((row) => rowPendingCount(row) > 0);
  if (!sorted.length) return null;
  const idx = sorted.findIndex((row) => row.assignmentId === currentId);
  const next = sorted[(idx + 1) % sorted.length];
  return next && next.assignmentId !== currentId ? next.assignmentId : (sorted.length > 1 ? sorted[0].assignmentId : null);
}

export const STATE_LABEL = { pending: '확인 필요', check: '점검', ok: '정상' };
